import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
ReactDOM.render(React.createElement(App, null), document.getElementById("root"));
registerServiceWorker();



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 621
// module chunks = 0